import React from "react";
import styles from "./style.module.css";

const Card = ({title, description, icon , index}) => {
  return (
    <div className={styles.card}>
      <div className={styles.leftContent}>
        <h5 className={styles.title}>{title}</h5>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.rightContent}>
       <img src={icon} alt="" />
       
        <p className={styles.smallDesc}>{title}</p>
      </div>
    </div>
  );
};

export default Card;
